<style lang="less" scoped>
.body {top: 1% !important; left: 1% !important; bottom: 2% !important; right: 1% !important;}
.border {box-shadow: 1px 0px 5px 1px #c7c7c7; border-radius: 10px;}
.mybtn {margin: 5px;}
.btnIcon {font-size: 14px; font-weight: bold;}
.bread {padding: 13px;
  span {font-size: 16px; font-weight: bold;color: white;cursor: pointer;}
}
.isSel {background-color: #558d91;}
.dialog{/deep/.el-dialog__header{background: rgb(141, 221, 235);text-align: left;height: 20px;}position: absolute;top: 20px;}
.searchBtn {line-height: 38px;}
.searchInput{width: 260px;height:24px;margin-left: 4px;color: white; background-color:rgba(78, 73, 73, 0); border: solid 1px rgb(65, 134, 155); border-radius: 3px;}
.searchInput:focus{ outline:none; }
.el-button{width: 20px;}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <cx-layout gutters class="body">
    <cx-region region="north" class="border" :height="btnH" style="display: flex;">
      <el-tooltip v-for="btn in buttonList" :key="btn.name" effect="dark" :content="btn.name" placement="top">
        <el-button class="mybtn" :size="size" :disabled="btn.disabled" @click="btn.click" style="color: #23fffc; background-color: rgba(78, 73, 73, 0);border: none;"><i class="btnIcon" :class="btn.icon" style="margin-left: -7px;"></i></el-button>
      </el-tooltip>
      <div class="searchBtn">
        <input class="searchInput" size="small" placeholder="输入搜索关键字" v-model="searchVal" />
        <el-tooltip effect="dark" content="文件搜索" placement="top-start">
          <el-button :size="size" style="width:30px;" :disabled="!searchVal" type="primary" circle icon="el-icon-search" @click="onSearch"></el-button>
        </el-tooltip>
      </div>
    </cx-region>
    <cx-region region="center">
      <cx-layout gutters>
        <cx-region region="west" class="border" :width="menuW">
          <FileTree ref="fileTree" class="body" v-bind="fileTreeParam" @click="onClickDir"></FileTree>
        </cx-region>
        <cx-region region="center">
          <cx-layout gutters>
            <cx-region region="north" class="border" :height="btnH">
              <div v-if="showSearch" style="line-height: 25px; margin-left: 10px; margin-top: 5px;display:flex;">
                <el-button size="mini" style="width:30px;" type="success" circle icon="el-icon-back" @click="onBackFromSearch"></el-button>
                <div class="cx-d-ib" style="font-weight: bold; margin-left: 10px;color: white;"><span>文件检索结果，关键字：</span><span style="color: #23fffc;">{{searchVal}}</span></div>
              </div>
              <el-breadcrumb v-else separator-class="el-icon-arrow-right" class="bread">
                <el-breadcrumb-item v-for="(bread, index) in breadmenu" :key="bread.key">
                  <span @click="onBreadClick(bread, index)">{{bread.name}}</span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </cx-region>
            <cx-region region="center" class="border" style="padding: 6px 6px 0 12px" id="fileContainer">
              <div style="height: 100%; width: 100%; overflow: auto;" @click.ctrl="ctrlClick">
                <FileCard v-for="file in fileList" :key="file.text"
                  :class="{'isSel': isSelFile(file)}"
                  :file="file"
                  @click="onClickFile"
                  @dblclick="onDbClickFile">
                </FileCard>
                <el-dialog class="dialog" width="57%" :visible.sync="isdialogVisible" title="上传文件">
                  <el-upload
                    style="width: 100%;"
                    :action="url"
                    :on-success="onSuccess">
                    <i class="el-icon-upload" style="font-size: 30px;"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-dialog>
                <div id="tempDiv"></div>
                <cx-contextmenu ref="contextmenu" :func="func" :funcgrp="funcgrp"/>
              </div>
            </cx-region>
          </cx-layout>
        </cx-region>
      </cx-layout>
    </cx-region>
  </cx-layout>
</template>

<script>
/** 插件 - 通用的文档管理 */
/**
 * SQL: insert into plugin (SYS, NAME, NAMEE, NAMEC, TITLEE, TITLEC, AUTORUN, CLOSEABLE, AUTOOBJ, PREREQ, UITYPE, MODAL, CONTAINER, RUNN, IDUI, PLUGIN, DIR, CLASSURL, UIURLE, UIURLC, ICON, ALIGN, WIDTH, HEIGHT, SERVICE, INITPARA, BUTTON, CATA)
 *      values ('11', 'FileManage', null, null, 'FileManage', '附件管理', 0, 1, null, null, 1, 0, null, 0, null, null, 'plugins/cx/', 'FileManage.vue', null, null, '.FileManage', 1, 1000, 500, null, null, null, 'Cx');
 * 调用参数。
 * @param {Object}                      params                      参数
 * @param {Number}                      params.major                附件所关联的主类型
 * @param {Number}                      params.minor                附件所关联的子类型
 * @param {String}                      params.rootfile             附件所存放的根目录。以uploadfile文件夹开始
 *
 * @param {Array<String || Object>}     [params.defFolders]         默认的子目录集合，没有会创建
 * @example
 * defFolders里面的元素可以是字符串，也可以是对象：
 *    如果没有子目录，就用字符串
 *    如果有嵌套的默认目录，则用对象形式，如：['目录1', '目录2', {name: '目录3', children: ['目录3-1', {name: '目录3-2', children: ['目录3-2-1']}]}]
 *      其中：name为这个目录的名字。 children放它的子目录的集合
 * @param {Number}                      [params.id]                 附件所关联的实体id
 * @param {Boolean}                     [params.editable=true]      是否可编辑，默认为true
 * @param {Boolean}                     [params.showAll=false]      是否显示所有按钮，是的话，不走权限，展示所有按钮。
 * @param {Function}                    [params.onDelFile]          删除附件时的回调函数
 * @param {Function}                    [params.onUploadSuccess]    附件上传成功时的回调函数
 * @param {Function}                    [params.filterFunc]         文件过滤函数
 * @param {Function}                    [params.filterTreeFunc]     左侧目录树的过滤函数
 */
import FileTree from './FileTree'
import FileCard from './FileCard'
import File from './js/File'
import ContextmenuCfg from './js/ContextmenuCfg'
export default {
  mixins: [ContextmenuCfg],
  components: {FileTree, FileCard},
  props:
  {
    size: {type: String, default: 'mini'},
    params: {type: Object, required: true}
  },
  data()
  {
    return {
      btnH: 40,
      menuW: 250,
      buttonList: [],
      selPath: null,     //当前目录的全路径
      selFile: null,     //当前选中的文件
      selFileList: [],   //当前框选的文件集合
      checkList: [],     //多选的文件集合
      rootFileList: [],  //根目录下的文件列表
      breadmenu: [],
      fileList: [],      //文件卡片集合
      rootDir: this.params.rootfile,
      editable: true,
      showAll: false,
      tempDivLeft: 0,
      tempDivTop: 0,
      tempDivRight: 0,
      tempDivBottom: 0,
      isdialogVisible: false,
      url: '',
      searchVal: '',
      showSearch: false,
      adminName: '',
      hideUploadEdit: false
    }
  },
  computed:
  {
    rootDirs()
    {
      return this.rootDir.split('/').filter(item => item)
    },
    fileTreeParam()
    {
      return {
        rootDir: this.rootDir,
        curPath: this.selPath,
        readOnly: !this.editable,
        defFolders: this.params.defFolders || [],
        filterTreeFunc: this.params.filterTreeFunc
      }
    }
  },
  watch:
  {
    'selFile': 'refreshBtn',
    selPath()
    {
      this.makeBreadMenu()
      this.makeFiles()
    }
  },
  created()
  {
    this.predata()
    if (localStorage.getItem('username'))
    {
      let paras = {cmd: 'query', _major: 11, _minor: 28, _exp: `username = '${localStorage.getItem('username')}'`}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length === 1)
          this.adminName = ret[0].passport
      })
    }
  },
  mounted()
  {
    this.dom = document.querySelector('#tempDiv')
    document.querySelector('#fileContainer').addEventListener('mousedown', this.onmousedown)
    document.addEventListener('mouseup', this.onmouseup)
  },
  beforeDestroy()
  {
    document.removeEventListener('mouseup', this.onmouseup)
  },
  methods:
  {
    ctrlClick()
    {
      alert('ctrlclick')
    },
    /**
     * 返回上层目录
     * @method
     */
    backFolder()
    {
      if (this.breadmenu.length === 1)
        return this.$message({message: '当前已是根目录！', type: 'warning'})
      this.onBreadClick(null, this.breadmenu.length - 2)
    },
    /**
     * 批量文件上传（zip压缩包上传后的回调函数）
     * @method
     * @param   {Object}  att   上传成功的zip文件的属性对象
     * @returns {Promise}
     */
    batchUpload(att)
    {
      let param =
      {
        cmd: 'unzipMedia',
        major: 99,
        minor: 45,
        entityid: this.params.id || 0,
        username: 1,
        sys: 11,
        filename: att.filename,
        dir: this.getUsefullPath(this.selPath)
      }
      return cx.http.post(cx.url.getUrl('DocSvr'), param)
    },
    /**
     * 根据文件路径返回有效的文件路径（截掉根目录的路径）
     * @method
     * @param   {String}    path    文件路径
     * @returns {String}    有效路径
     */
    getUsefullPath(path)
    {
      //判断path是否以uploadfile开始
      let rootDir = 'uploadfile/'
      if (path.indexOf(rootDir) !== -1)
        path = path.substring(path.indexOf(rootDir) + rootDir.length)
      return path
    },
    /**
     * 获取文件的全路径
     * @method
     * @param   {Object}    file    文件或者文件夹的属性对象
     * @returns {String}    全路径(从uploadfile开始)
     */
    getFilePath(file = this.selFile)
    {
      if (file.children)
        return file.path
      return this.selPath + file.text
    },
    /**
     * 根据index在this.menu中拿到其对应的menu属性对象。
     * @method
     * @param   {String}              index   当前选中目录的index
     * @param   {Array.Object}        menu    目录对象数组
     * @returns {Object}
     */
    getMenuByIndex(index, menu)
    {
      for (let item of menu)
      {
        if (item.text === index)
          return item
        if (item.children && item.children.length !== 0)
        {
          let obj = this.getMenuByIndex(index, item.children)
          if (obj !== undefined)
            return obj
        }
      }
    },
    /**
     * 获取文件上传时的serverlet名
     * @method
     * @returns   {String}
     */
    getUploadServerlet()
    {
      return cx.url.getUrl('DocSvr')
    },
    /**
     * 获取文件上传的参数对象
     * @method
     * @param   {Boolean}   [isBatch=false]   是否是批量文件上传
     * @returns   {Object}
     */
    getUploadParam(isBatch = false)
    {
      return  {
        cmd: 'upload',
        major: this.params.major,
        minor: this.params.minor,
        entityid: this.params.id || 1,
        username: 1,
        sys: 11,
        fid: 1,
        glid: this.selNode.id || '0',
        task: '',
        dir: this.selPath.substring(this.selPath.indexOf('/') + 1, 1000),
        ...this.getOtherUploadParam(isBatch = false),
        _auth: cx.http.getAuth()

      }
    },
    /**
     * 获取文件上传的额外参数对象
     * @method
     * @param   {Boolean}   [isBatch=false]   是否是批量文件上传
     * @returns   {Object}
     */
    getOtherUploadParam(isBatch = false)
    {
      return {}
    },
    /**
     * 实例化文件管理类
     * @method
     */
    initFileClass()
    {
      this.File = new File()
    },
    /**
     * 当用户进行操作时会被触发，中断用户操作，提示用户进行输入的对话框。
     * @method
     * @param   {String}  title     提示语
     * @param   {String}  [defVal]  默认值
     * @returns {Promise}
     */
    inputConfirm(title, defVal = '')
    {
      return new Promise((resolve, reject) =>
      {
        this.$prompt(title, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: defVal
        }).then(({ value }) =>
        {
          resolve(value || defVal)
        }).catch(() =>
        {
          this.$message({message: '取消输入', type: 'info'})
        })
      })
    },
    /**
     * 根据文件名判断是不是图片文件或者pdf文件
     * @method
     * @param   {String}      name    文件名称
     * @returns {Boolean}
     */
    canView(name = this.selFile && this.selFile.text)
    {
      if (!name)
        return false
      let type = name.split('.')[name.split('.').length - 1].toUpperCase()
      return ['PNG', 'JPG', 'JPEG', 'BMP', 'TIF', 'GIF'].indexOf(type) !== -1 || ['3GP', 'AVI', 'ASF', 'ASX', 'FLV', 'MOV', 'MPG', 'MP4', 'OGG', 'WEBM', 'WMV'].indexOf(type) !== -1  || type === 'PDF'
    },
    isSelFile(file)
    {
      return this.selFile && this.selFile.text === file.text
    },
    /**
     * 构造面包屑菜单栏
     * @method
     */
    makeBreadMenu()
    {
      let curDir = this.rootDirs[this.rootDirs.length - 1] + this.selPath.replace(this.rootDirs.join('/'), '')
      this.breadmenu = curDir.split('/').filter(item => item).map(item => ({key: item, name: item}))
    },
    /**
     * 构造顶部按钮组
     * @method
     * @returns   {Object}    按钮组
     */
    makeBtnList()
    {
      let btns =
      [
        {name: '新建目录', key: 'addFolder', icon: 'el-icon-folder-add', click: this.onAddMenu, disabled: true, disFunc: _ => !this.selPath, isShow: this.editable},
        {name: '删除目录', key: 'deleteFolder', icon: 'el-icon-folder-delete', click: this.onDeleteMenu, disabled: true, disFunc: _ => !(this.selPath && this.selPath !== this.rootDir), isShow: this.editable},
        {name: '删除文件', key: 'delete', icon: 'el-icon-delete', click: this.onDelFile, disabled: true, disFunc: _ => !this.selFile || !!this.selFile.children, isShow: this.editable},
        // {name: '批量删除', key: 'batchdelete', icon: 'el-icon-delete', click: this.onDelFiles, disabled: true, disFunc: _ => !this.checkList, isShow: this.editable},
        {name: '文件上传', key: 'upload', icon: 'el-icon-upload2', click: _ => this.onUpload(), disabled: true, disFunc: _ => !(this.selPath && this.selPath !== this.rootDir), isShow: this.editable},
        // {name: '批量上传', key: 'batchUpload', icon: 'el-icon-upload2', click: this.onBatchUpload, disabled: true, disFunc: _ => !(this.selPath && this.selPath !== this.rootDir), isShow: this.editable},
        {name: '文件下载', key: 'download', icon: 'el-icon-download', click: this.onDownload, disabled: true, disFunc: _ => !this.selFile || !!this.selFile.children, isShow: true},
        // {name: '批量下载', key: 'batchdownload', icon: 'el-icon-download', click: this.onDownloads, disabled: true, disFunc: _ => !this.checkList, isShow: true},
        {name: '文件预览', key: 'fileview', icon: 'el-icon-view', click: this.onFileView, disabled: true, disFunc: _ => !this.canView(), isShow: true}
      ]
      let btnMap = cx.array.listToMap(btns.filter(btn => btn.isShow), 'key')
      for (let key in btnMap)
        btnMap[key] = btnMap[key][0]
      return btnMap
    },
    /**
     * 根据当前路径构建完整目录路径
     * @method
     * @param {Array.String}  indexPath  当前目录路径
     */
    makeCompleteDir(indexPath)
    {
      let dir = this.params.rootfile + '/'
      for (let path of indexPath)
        dir += path + '/'
      return dir
    },
    /**
     * 构造当前目录下的文件和文件夹数据
     * @method
     */
    makeFiles()
    {
      this.selFile = null
      this.refreshBtn()
      this.File.queryDirFiles(this.selPath).then(ret =>
      {
        let files = ret[0].children.sort(this.sortFile)
        if (this.params.filterFunc)
          files = files.filter(this.params.filterFunc)
        this.fileList = files
      }).catch(this.onError)
    },
    sortFile(fileA, fileB)
    {
      return fileA.children ? -1 : 1
    },
    /**
     * 新建目录按钮的响应事件。
     * @method
     */
    onAddMenu()
    {
      if (this.adminName === '')
        this.$message({message: '请登录后再进行相关操作', type: 'error'})
      else
        this.$refs.fileTree.onAddFolder(this.makeFiles)
    },
    /**
     * 文件批量上传
     * @method
     */
    onBatchUpload()
    {
      this.onUpload(true)
    },
    /**
     * 面包屑节点点击响应事件
     * @method
     * @param {Object}  bread 当前选中的节点属性对象。
     */
    onBreadClick(bread, index)
    {
      //1、根据当前点击的index更新this.breadmenu
      this.breadmenu = this.breadmenu.slice(0, index + 1)
      //2、更新this.selPath
      this.selPath = this.rootDirs.concat(this.breadmenu.slice(1).map(item => item.name)).join('/') + '/'
    },
    /**
     * 点击左边目录树上的节点时的响应函数
     * @method
     * @param   {Object}    data    目录节点对应的数据对象
     * @param   {Object}    node    目录节点对象
     */
    onClickDir(data, node)
    {
      this.selNode = data
      this.selFile = data
      this.selPath = data.path
    },
    /**
     * 单击文件或者文件夹时的响应函数
     * @method
     * @param   {Object}    file    文件或者文件夹对象。格式如: 文件: {text: '11.sql'},  文件夹: {children: [], path: 'uploadfile/文档数据/文档/', text: '文档'}
     */
    onClickFile(file)
    {
      this.selFile = file
    },
    /**
     * 右键点击文件或者文件夹时的响应函数
     * @method
     * @param   {Object}    file    文件或者文件夹对象
     */
    // onContextFile(file)
    // {
    //   this.selFile = file
    //   this.contextFile = file
    // },
    /**
     * 双击文件或者文件夹时的响应函数。
     * @method
     * @param   {Object}    file    文件或者文件夹对象。文件:{text: '11.sql'}
     */
    onDbClickFile(file)
    {
      if (file.children)
        this.openFolder(file)
      else
      {
        this.selFile = file
        this.onFileView()
      }
    },
    /**
     * 根据文件路径构造文件加载的src
     * @method
     * @param   {Array<String>}   paths     文件路径集合。
     * @returns {Atray<Stirng>}   构造好的文件src集合
     */
    makeFileSrcByPath(path, isTempFile = 0)
    {
      return `${cx.url.getUrl('DocGetSvr')}?cmd=getFile&tempFile=${isTempFile}&filenames=${this.getUsefullPath(path)}&saveas=${path.split('/').pop()}`
    },
    /**
     * 文件下载
     * @method
     * @param   {String}     src        文件加载的src
     * @param   {String}     [title]    文件下载名
     */
    download(src, title = '文件下载')
    {
      let domA = document.createElement('a')    //创建一个a标签,用做后面的模拟点击下载操作。
      domA.href = src       //绑定a标签的下载地址
      domA.download = title     //绑定a标签的下载文件名
      domA.click()                  //模拟点击实现下载
    },
    /**
     * 删除附件的触发事件。
     * @method
     */
    onDelFile()
    {
      if (this.adminName === '')
        this.$message({message: '请登录后再进行相关操作', type: 'error'})
      else
      {
        this.$confirm(`是否确认删除该文件【${this.selFile.text}】？`)
          .then(() =>
          {
            this.File.delFile({paths: this.getFilePath(), ids: this.selFile.id}).then(_ =>
            {
              this.$message({message: '删除成功', type: 'success'})
              this.makeFiles()
              cx.base.call(this.params.onDelFile, this)
            })
          })
          .catch(() =>
          {
          })
      }
    },
    /**
     * 批量删除附件的触发事件。
     * @method
     */
    onDelFiles()
    {
      this.checkList = this.fileList.filter(file => this.selFileList.some(selFile => selFile.text === file.text))
      this.File.delFile({paths: this.checkList.map(item => this.getFilePath(item)).toString(), ids: cx.array.toString(this.checkList, 'id')}).then(_ =>
      {
        this.$message({message: '删除成功', type: 'success'})
        this.makeFiles()
      })
    },
    /**
     * 删除当前选中的目录，如果有子目录的话添加提醒。
     * @method
     */
    onDeleteMenu()
    {
      if (this.adminName === '')
        this.$message({message: '请登录后再进行相关操作', type: 'error'})
      else
      {
        this.$refs.fileTree.onDelFolder(this.selFile, _ =>
        {
          let paths = this.selPath.split('/').filter(str => str.trim() !== '')
          this.selPath = paths.slice(0, paths.length - 1).join('/') + '/'
          this.makeFiles()
        })
      }
    },
    /**
     * 文件栏上方的按钮点击事件
     * @method
     * @param   {Object}    button    按钮配置属性对象
     */
    onClick(button)
    {
      eval('this.' + button.click)()
    },
    /**
     * 异常处理函数
     * @method
     * @param   {Object}    err   异常信息对象
     */
    onError(err)
    {
      this.$showRet(err)
    },
    /**
     * 附件上传
     * @method
     * @param   {Boolean}   [isBatch=false]   是否是批量文件上传
     */
    onUpload(isBatch = false)
    {
      if (this.adminName === '')
        this.$message({message: '请登录后再进行相关操作', type: 'error'})
      else
      {
        setTimeout(() =>
        {
          let dom = document.getElementsByClassName('v-modal')
          dom[0].remove()
        }, 0)
        this.isdialogVisible = true
        let faDir = this.getUploadParam(isBatch)
        let Ip = window.location.hostname
        let UrlType = ''
        if (Ip === '127.0.0.1')
          UrlType = 'svr/DocSvr'
        else if (Ip === 'localhost')
          UrlType = 'svr/DocSvr'
        else
          UrlType = 'DocSvr'
        let data = {
          cmd: 'upload',
          major: 11,
          minor: 1,
          entityid: 1,
          username: 'name',
          fid: 1,
          sys: 11,
          task: '',
          dir: faDir.dir,
          glid: '0',
          _auth: cx.http.getAuth()
        }
        let params = {
          tempUrl: UrlType,
          title: faDir.dir,
          tip: '',
          data: data
        }
        this.url = `${params.tempUrl}?cmd=${data.cmd}&major=${data.major}&minor=${data.minor}&username=admin&fid=11&sys=11&dir=${params.title}&entityid=1&glid=0&task=Dmky`
      }
    },
    // 上传成功
    onSuccess(response)
    {
      let Ip = window.location.hostname
      let prefix = ''
      if (Ip === 'www.camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else if (Ip === 'camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else
        prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
      console.log(`${prefix}${response[0].filename}`)
      this.$message({message: '上传成功！', type: 'success'})
      this.makeFiles()
    },
    /**
     * 附件下载
     * @method
     */
    onDownload()
    {
      if (this.adminName === '')
        this.$message({message: '请登录后再进行相关操作', type: 'error'})
      else
      {
        let filenames = this.getFilePath(this.selFile).substring(this.getFilePath(this.selFile).indexOf('uploadfile/') + 11)
        this.download(this.makeFileSrcByPath(filenames))
      }
    },
    /**
     * 附件批量下载
     * @method
     */
    onDownloads()
    {
      this.checkList = this.fileList.filter(file => this.selFileList.some(selFile => selFile.text === file.text))
      for (let j = 0; j < this.checkList.length; j++)
      {
        let filenames = this.getFilePath(this.checkList[j]).substring(this.getFilePath(this.checkList[j]).indexOf('uploadfile/') + 11)
        cx.http.post(cx.url.getUrl('DocGetSvr'), {cmd: 'getFile', filenames, saveas: this.checkList[j].text})
      }
    },
    /**
     * 图片浏览
     * @method
     */
    onFileView(file = this.selFile)
    {
      if (this.adminName === '')
        this.$message({message: '请登录后再进行相关操作', type: 'error'})
      else
      {
        if (!this.canView(file.name))
          return this.$message({message: '当前文件类型暂不支持预览，请下载后查看！', type: 'error'})
        else
        {
          let Ip = window.location.hostname
          let prefix = ''
          if (Ip === 'www.camining.cn')
            prefix = 'http://www.camining.cn/'
          else if (Ip === 'camining.cn')
            prefix = 'http://www.camining.cn/'
          else
            prefix = 'http://192.168.2.201:8083/gisdm/'
          window.open(prefix + this.getFilePath(), '_blank')
        }
      }
    },
    /**
     * 打开文件夹
     * @method
     * @param   {Object}    [file=this.selFile]   文件夹对象
     */
    openFolder(file = this.selFile)
    {
      this.selPath = file.path
    },
    /**
     * 构造初始化数据。
     * @method
     */
    predata()
    {
      this.initFileClass()
      this.editable = this.params.editable !== undefined ? this.params.editable : this.editable
      this.showAll = this.params.showAll || this.showAll
      this.buttonList = this.makeBtnList()
      this.contextMenus =
      {
        folder:
        [
          {grp: 'folder', name: '打开目录', show: true, callback: this.openFolder},
          {grp: 'folder', name: '删除目录', show: this.editable, callback: this.onDeleteMenu}
        ],
        file:
        [
          // {grp: 'file', name: '查看文件', show: true, callback: this.onFileView},
          {grp: 'file', name: '删除文件', show: this.editable, callback: this.onDelFile},
          {grp: 'file', name: '下载', show: true, callback: this.onDownload}
        ],
        empty:
        [
          {grp: 'file', name: '新建文件夹', show: this.editable, callback: this.onAddMenu},
          {grp: 'file', name: '导入文件', show: this.editable, callback: this.onUpload},
          // {grp: 'file', name: '批量上传', show: this.editable, callback: this.onBatchUpload},
          {grp: 'file', name: '返回上级', show: true, callback: this.backFolder},
          {grp: 'file', name: '刷新', show: true, callback: this.makeFiles}
        ]
      }
      // this.selPath = this.rootDir
    },
    /**
     * 刷新文件列表上的按钮禁用状态
     * @method
     */
    refreshBtn()
    {
      for (let key in this.buttonList)
        this.buttonList[key].disabled = this.buttonList[key].disFunc(this)
    },
    /**
     * 显示右键菜单
     * @method
     * @param {Event} event 事件对象
     */
    showMenu(event)
    {
      event.preventDefault()
      this._contextmenu.clear()
      let menu = this.contextMenus.empty
      if (this.contextFile)
      {
        if (this.contextFile.children)
          menu = this.contextMenus.folder
        else
          menu = this.contextMenus.file
        this.contextFile = null
      }
      this._contextmenu.addCustom(menu)
      this._contextmenu.show({ top: event.clientY, left: event.clientX }, {})
    },
    /**
     * 监听鼠标事件
     * @method
     */
    onmousedown(e)
    {
      e.preventDefault()
      e.stopPropagation()
      this.isMouseDowm = true
      this.posx = e.clientX
      this.posy = e.clientY
      this.selFileList = []
      const cardlist = document.querySelectorAll('.card')
      for (let i = 0; i < cardlist.length; i++) cardlist[i].classList.remove('isSel')
      document.querySelector('#fileContainer').addEventListener('mousemove', this.onmousemove)
    },
    onmousemove(ev)
    {
      ev.preventDefault()
      ev.stopPropagation()
      if (!this.isMouseDowm) return
      const container =  document.querySelector('#fileContainer').getBoundingClientRect()
      this.dom.style.position = 'absolute'
      this.dom.style.background = '#A2CDFFF2'
      this.dom.style.width = Math.abs(this.posx - ev.clientX) + 'px'
      this.dom.style.height = Math.abs(this.posy - ev.clientY) + 'px'
      this.dom.style.top = Math.min(ev.clientY, this.posy) - container.top + 'px'
      this.dom.style.left = Math.min(ev.clientX, this.posx) - container.left + 'px'
      this.tempDivTop = Math.min(ev.clientY, this.posy)
      this.tempDivLeft = Math.min(ev.clientX, this.posx)
      this.tempDivRight = (this.tempDivLeft - 0) + (this.dom.style.width.split('px')[0] - 0)
      this.tempDivBottom = (this.tempDivTop - 0) + (this.dom.style.height.split('px')[0] - 0)
      const cardlist = document.querySelectorAll('.card')
      for (let i = 0; i < cardlist.length; i++)
      {
        const cardSort = cardlist[i].getBoundingClientRect()
        let left = cardSort.left
        let right = cardlist[i].offsetWidth + left
        let top = cardSort.top
        let bottom = cardlist[i].offsetHeight + top
        let leftFlag = ((this.tempDivLeft <= left) && (left <= this.tempDivRight))
        let rightFlag = ((this.tempDivLeft <= right) && (right <= this.tempDivRight))
        let topFlag = ((this.tempDivTop <= top) && (top <= this.tempDivBottom))
        let bottomFlag = ((this.tempDivTop <= bottom) && (bottom <= this.tempDivBottom))
        if ((leftFlag || rightFlag) && (topFlag || bottomFlag)) cardlist[i].classList.add('isSel')
        else cardlist[i].classList.remove('isSel')
      }
    },
    onmouseup()
    {
      document.querySelector('#fileContainer').removeEventListener('mousemove', this.onmousemove)
      this.posx = 0
      this.posy = 0
      this.dom.style.left = 0
      this.dom.style.top = 0
      this.dom.style.width = 0
      this.dom.style.height = 0
      this.tempDivLeft = 0
      this.tempDivTop = 0
      this.tempDivRight = 0
      this.tempDivBottom = 0
      this.selFileList = []
      this.isMouseDowm = false
      const cardlist = document.querySelectorAll('.card')
      for (let i = 0; i < cardlist.length; i++)
      {
        const classIndex = cardlist[i].className.indexOf('isSel')
        const textList = {text: cardlist[i].innerText}
        if (classIndex !== -1) this.selFileList.push(textList)
      }
    },
    onBackFromSearch()
    {
      this.showSearch = false
      this.makeFiles()
    },
    /**
    * 从当前目录开始进行 文件检索
    * @method
    */
    async onSearch()
    {
      try
      {
        this.showSearch = true
        // 1、首先找到当前目录下的所有文件夹和文件
        const [dirFiles] = await this.File.queryDirFiles(this.selPath)
        // 2、从dirFiles中找到包含当前关键字的所有文件
        let result = []
        const findFile = (faPath, list) =>
        {
          if (!list || !list.length)
            return
          list.forEach(item =>
          {
            if (item.text.indexOf(this.searchVal) !== -1)
            {
              if (item.children)
                return findFile(item.path, item.children)
              result.push({...item, filePath: faPath})
            }
            else if (item.children)
              findFile(item.path, item.children)
          })
        }
        findFile(this.selPath, dirFiles.children)
        this.fileList = result
      }
      catch (err)
      {
        this.$showRet(err)
      }
    }
  }
}
</script>1





// WEBPACK FOOTER //
// src/plugins/app/com/fileManage/FileManage.vue